import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=dda43d84&scoped=true&"
import script from "./FacebookLogin.vue?vue&type=script&lang=js&"
export * from "./FacebookLogin.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=dda43d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda43d84",
  null
  
)

/* custom blocks */
import block0 from "./FacebookLogin.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports